import {
  deprecatedColors,
  deprecatedTones,
} from "@src/deprecatedDesignSystem/styles/deprecatedColors";
import MiscStyles from "./MiscStyles";
import { StyleSheet } from "aphrodite";

export default StyleSheet.create({
  iconButton: {
    padding: 2,
    cursor: "pointer",
    ":hover": {
      backgroundColor: deprecatedTones.gray5Alpha,
      borderRadius: 8,
    },
  },
  buttonSquare: {
    height: 40,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "0 16px",
    fontSize: 14,
    borderRadius: 8,
    cursor: "pointer",
  },
  buttonRounded: {
    cursor: "pointer",
    fontSize: 14,
    borderRadius: 12,
    height: 32,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "0 16px",

    outline: "none",
  },
  buttonPrimary: {
    backgroundColor: deprecatedColors.primary,
    color: deprecatedColors.onPrimary,
    whiteSpace: "nowrap",
    outline: "none",
    border: "1px solid transparent",
    textDecoration: "none",
    ":disabled": {
      color: deprecatedColors.onDisabled,
      backgroundColor: deprecatedColors.disabled,
      pointerEvents: "none",
    },
    "&.loading": {
      pointerEvents: "none",
    },
    ":hover:not(:disabled)": {
      backgroundColor: deprecatedTones.blue10,
    },
    ":active:not(:disabled):not(.loading)": {
      ...MiscStyles.focus,
    },
  },
  buttonSecondary: {
    fontWeight: 500,
    color: deprecatedColors.onPrimaryContainer,
    border: `1px solid ${deprecatedColors.border}`,
    backgroundColor: deprecatedColors.background,
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.03)",
    whiteSpace: "nowrap",
    ":disabled": {
      pointerEvents: "none",
      color: deprecatedTones.gray6,
    },
    "&.loading": {
      pointerEvents: "none",
    },
    ":hover:not(:disabled)": {
      background: deprecatedTones.gray4Alpha,
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.03)",
    },
    ":active:not(:disabled):not(.loading)": {
      ...MiscStyles.focus,
    },
  },
  buttonTertiary: {
    color: deprecatedColors.onSurface,
    backgroundColor: "transparent",
    whiteSpace: "nowrap",
    border: "1px solid transparent",
    ":disabled": {
      color: deprecatedTones.gray6,
      pointerEvents: "none",
    },
    "&.loading": {
      pointerEvents: "none",
    },
    ":hover:not(:disabled):not(.loading)": {
      background: deprecatedTones.gray4Alpha,
    },
    ":active:not(:disabled)": {
      ...MiscStyles.focus,
    },
  },
  buttonTransparent: {
    color: deprecatedColors.background,
    textDecoration: "none",
    backdropFilter: "blur(2px)",
    backgroundColor: deprecatedTones.gray10Alpha,
    whiteSpace: "nowrap",
    border: `1px solid ${deprecatedColors.background}`,
    ":active:not(:disabled)": {
      ...MiscStyles.focus,
    },
  },
  buttonTransparentDarker: {
    color: deprecatedColors.background,
    textDecoration: "none",
    backdropFilter: "blur(2px)",
    backgroundColor: deprecatedTones.gray11Alpha,
    whiteSpace: "nowrap",
    fontWeight: 500,
    fontSize: 14,
  },
  buttonAlert: {
    color: deprecatedColors.error,
    backgroundColor: deprecatedColors.onError,
    ":disabled": {
      color: deprecatedColors.onDisabled,
      backgroundColor: deprecatedColors.disabled,
      pointerEvents: "none",
    },
    "&.loading": {
      pointerEvents: "none",
    },
    ":hover:not(:disabled)": {
      background: deprecatedTones.red11,
    },
    ":active:not(:disabled):not(.loading)": {
      ...MiscStyles.focusError,
    },
  },
  buttonFilled: {
    backgroundColor: deprecatedTones.gray4Alpha,
    padding: "4px 8px",
    color: deprecatedColors.onBackground,
    borderRadius: 6,
    border: "1px solid transparent",
    fontWeight: 500,
    fontSize: 14,
    lineHeight: "24px",
    whiteSpace: "nowrap",
    outline: "none",
    ":hover": {
      cursor: "pointer",
      backgroundColor: deprecatedTones.gray4Alpha,
    },
  },
  enabledFilledButton: {
    backgroundColor: deprecatedTones.blue2,
    ":hover": {
      backgroundColor: deprecatedTones.blue2,
    },
  },
  buttonBlue: {
    backgroundColor: deprecatedColors.primary,
    padding: "4px 8px",
    color: deprecatedColors.onPrimary,
    borderRadius: 16,
    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.03)",
    border: "1px solid transparent",
    fontWeight: 500,
    fontSize: 14,
    lineHeight: "24px",
    whiteSpace: "nowrap",
    ":hover": {
      cursor: "pointer",
      backgroundColor: deprecatedTones.blue10,
    },
    ":active:not(:disabled):not(.loading)": {
      ...MiscStyles.focus,
    },
  },
});
